import {
  collection,
  doc,
  DocumentData,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  setDoc,
} from "firebase/firestore";
import { fireStore } from "./firebase";
import { UserInterface } from "./types";

export const COLLECTION = {
  USERS: "users",
  NOTICE: "notice",
};

/**
 * 내 정보 가져오기
 */
export const getMyBestScore = async (user: UserInterface) => {
  const res = await getDoc(
    doc(fireStore, COLLECTION.USERS, user.uid as string)
  );
  return res.data();
};

/**
 * 내 점수 저장하기
 */
export const setMyBestScore = async (
  user: UserInterface,
  score: number,
  star?: number
) => {
  await setDoc(doc(fireStore, COLLECTION.USERS, user.uid as string), {
    ...user,
    bestScore: score,
    star,
  });
};

/**
 * 랭킹 가져오기
 */
export const getRanking = async () => {
  const q = query(
    collection(fireStore, COLLECTION.USERS),
    orderBy("bestScore", "desc"),
    limit(10)
  );

  const querySnapshot = await getDocs(q);

  const list: DocumentData[] = [];
  querySnapshot.forEach((d) => list.push(d.data()));

  return list;
};

/**
 * Top3 가져오기
 */
export const getTopUsers = async () => {
  const q = query(
    collection(fireStore, COLLECTION.USERS),
    orderBy("bestScore", "desc"),
    limit(3)
  );

  const querySnapshot = await getDocs(q);

  const list: DocumentData[] = [];
  querySnapshot.forEach((d) => list.push(d.data()));

  return list;
};

/**
 * 공지 가져오기
 */
export const getNotice = async () => {
  const res = await getDoc(doc(fireStore, COLLECTION.NOTICE, "1"));
  return res.data();
};
